import { helpers } from 'vuelidate/lib/validators'

const isArray = (value) => !helpers.req(value) || Array.isArray(value)

export default isArray;